import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Checkbox, CircularProgress, FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../Services/ServiceLocator";
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import { v4 as uuid } from 'uuid';
import { DateTimePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from "dayjs";
import { dateTimePickerToUtc } from "../../utils/dateUtils";
import WorkshopTemplate from "./WorkshopTemplate";

import { AuthenticationService } from "../../Services/AuthenticationService";
import { getNumberInputDisplayValue, parseNumberInputValue } from '../../utils/numberInputUtils';
const styles = theme => ({
    wrapper: {
        margin: -5,
    },
});

let assemblies;
let subAssemblies;
let parts;
let salesLogSources;

class Sell extends React.Component {
    state = {
        loading: true,
        user: {},
        users: [],
        quantity: 0,
        newLogReason: '',
        newLogSource: 'Customer Service',
        newLogOrderNumber: '',
        newLogOrderDate: new Date(),
        newLogOrderDateManuallyChanged: false,
        newLogAffectsProjections: true
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Purchase')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts(), self.loadSalesLogSources()]).then(() => {
            const partOrAssembly = globalProps.match.params.partOrAssembly;
            const assembly = assemblies.find(x => x.assembly.id === partOrAssembly);
            const subAssembly = subAssemblies.find(x => x.subAssembly.id === partOrAssembly);
            const part = parts.find(x => x.part.id === partOrAssembly);
            self.setState({loading: false, assemblies, subAssemblies, assembly, subAssembly, part, user, salesLogSources, permissions: user.userPermissions});
        });
    };

    loadAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assemblies = assembliesResult.sort(function (a, b) {
                if (a.assembly.assemblyId > b.assembly.assemblyId) return 1;
                if (b.assembly.assemblyId > a.assembly.assemblyId) return -1;
                return 0;
            });
        });
    };

    loadSubAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssemblies = subAssembliesResult.sort(function (a, b) {
                if (a.subAssembly.subAssemblyId > b.subAssembly.subAssemblyId) return 1;
                if (b.subAssembly.subAssemblyId > a.subAssembly.subAssemblyId) return -1;
                return 0;
            });
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            parts = partsResult.sort(function (a, b) {
                if (a.part.partId < b.part.partId) return -1;
                if (a.part.partId > b.part.partId) return 1;
                return 0;
            });
            self.setState({parts});
        });
    };

    loadSalesLogSources = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.getSalesLogSources().then((salesLogSourcesResult) => {
            salesLogSources = salesLogSourcesResult.sort((a, b) => a.source > b.source ? 1 : -1);
        });
    };

    changeSource = (newValue) => {
        this.setState({newLogSource: newValue});
    };

    changeOrderNumber = (event) => {
        this.setState({newLogOrderNumber: event.target.value});
    };

    changeReason = (event) => {
        this.setState({newLogReason: event.target.value});
    };

    addManualLog = () => {
        const self = this;
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        if (this.state.newLogSource === '') return window.$alertWarning("You must select a source for this log");

        const partOrAssembly = globalProps.match.params.partOrAssembly;
        const assembly = assemblies.find(x => x.assembly.id === partOrAssembly);
        const subAssembly = subAssemblies.find(x => x.subAssembly.id === partOrAssembly);
        const part = parts.find(x => x.part.id === partOrAssembly);

        self.setState({savingLog: true});
        const payload = {
            id: uuid(),
            source: this.state.newLogSource,
            quantity: parsedQuantity,
            reason: this.state.newLogReason,
            orderNumber: this.state.newLogOrderNumber,
            partId: part ? part.part.id : null,
            assemblyId: assembly ? assembly.assembly.id : null,
            subAssemblyId: subAssembly ? subAssembly.subAssembly.id : null,
            logDate: this.state.newLogOrderDateManuallyChanged
                ? dateTimePickerToUtc(this.state.newLogOrderDate)
                : dateTimePickerToUtc(new Date()),
            affectsProjections: this.state.newLogAffectsProjections,
            isManuallyAssigned: true,
            userId: AuthenticationService.getInstance().getUserId(),
            status: 'Fulfilled'
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.importSalesLogs([payload]).then(() => {
            window.$alertSuccess("Sales log created");
            self.setState({savingLog: false, completed: true});
        });
    };

    render() {
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {assembly, subAssembly, part} = this.state;

        if (!assembly && !subAssembly && !part) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Log complete!</h2>
                        {part ?
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => globalProps.history.push(`/search/${this.state.part.part.id}`)}
                                className="success-button-lg"
                            >
                                Part Home
                            </Button>
                            : ''}
                        {assembly ?
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => globalProps.history.push(`/search/${this.state.assembly.assembly.id}`)}
                                className="success-button-lg"
                            >
                                Assembly Home
                            </Button>
                            : ''}
                        {subAssembly ?
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => globalProps.history.push(`/search/${this.state.subAssembly.subAssembly.id}`)}
                                className="success-button-lg"
                            >
                                SubAssembly Home
                            </Button>
                            : ''}
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {part ?
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => globalProps.history.push(`/search/${part.part.id}`)}
                            className="success-button-lg"
                        >
                            Part Home
                        </Button>
                        : ''}
                    {assembly ?
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => globalProps.history.push(`/search/${assembly.assembly.id}`)}
                            className="success-button-lg"
                        >
                            Assembly Home
                        </Button>
                        : ''}
                    {subAssembly ?
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => globalProps.history.push(`/search/${subAssembly.subAssembly.id}`)}
                            className="success-button-lg"
                        >
                            SubAssembly Home
                        </Button>
                        : ''}
                    <h2>
                        Sell
                        <br/>
                        {part ? `${part.part.partId} rev ${part.part.revision}` : ''}
                        {assembly ? `${assembly.assembly.assemblyId} rev ${assembly.assembly.revision}` : ''}
                        {subAssembly ? `${subAssembly.subAssembly.subAssemblyId} rev ${subAssembly.subAssembly.revision}` : ''}
                    </h2>
                    <div style={{marginTop: -8, marginBottom: 16, color: '#666'}}>
                        {part ? (part.part.description || 'No description') : ''}
                        {assembly ? (assembly.assembly.description || 'No description') : ''}
                        {subAssembly ? (subAssembly.subAssembly.description || 'No description') : ''}
                    </div>
                    <div style={{marginBottom: 20}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                label="Order Date"
                                value={this.state.newLogOrderDate}
                                onChange={(newValue) => this.setState({newLogOrderDate: newValue, newLogOrderDateManuallyChanged: true})}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel id="cost-type-select-label">Source</InputLabel>
                        <Select value={this.state.newLogSource} style={{width: '100%', marginBottom: 20, textAlign: 'left'}} label="Source">
                            {this.state.salesLogSources.map((source) => {
                                return (<MenuItem value={source.source}
                                                  onClick={() => this.changeSource(source.source)}>{source.source}</MenuItem>)    ;
                            })}
                        </Select>
                    </FormControl>
                    <TextField onChange={this.changeOrderNumber} label={"Dealer Order #"} variant="outlined" inputProps={{maxLength: 20}}
                               style={{width: '100%', marginBottom: 20}}
                               autoComplete="off"/>
                    <TextField onChange={this.changeReason} label={"Reason"} variant="outlined" inputProps={{maxLength: 500}}
                               style={{width: '100%', marginBottom: 20}}
                               autoComplete="off"/>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 1).toString()})}}
                    >
                        -1
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 1).toString()})}}
                    >
                        1
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 2).toString()})}}
                    >
                        2
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 4).toString()})}}
                    >
                        4
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 10).toString()})}}
                    >
                        10
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 20).toString()})}}
                    >
                        20
                    </Button>
                    <Button 
                        variant="contained"
                        color="primary"
                        className="success-button-lg quantity-button" 
                        style={{margin: 10}}
                        onClick={(event) => {this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 100).toString()})}}
                    >
                        100
                    </Button>
                    <br/><br/>
                    <TextField
                        placeholder="Quantity Sold"
                        label="Quantity Sold"
                        variant="outlined" inputProps={{inputMode: 'numeric'}}
                        onChange={(event) => this.setState({quantity: event.target.value})}
                        value={this.state.quantity || ''}
                        autoComplete="off"
                    />
                    <br/><br/>
                    <Checkbox onClick={(event) => {
                        this.setState({newLogAffectsProjections: event.target.checked})
                    }} checked={this.state.newLogAffectsProjections} style={{padding: 0}}/> Should this affect sales projections?
                    <br/><br/>
                    {this.state.savingLog === true ?
                        <CircularProgress/>
                        :
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={this.addManualLog}
                            className="success-button-lg"
                        >
                            Save
                        </Button>
                    }
                </div>
            </WorkshopTemplate>
        )
            ;
    }
}

let globalProps;

Sell.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Sell);
